import React from 'react';

const ComicPanel = ({ children, title, className = '', color = 'bg-white' }) => {
  return (
    <div className={`
      relative border-4 border-black shadow-comic p-6 ${color} ${className}
    `}>
      {title && (
        <div className="absolute -top-5 left-4 bg-comic-red border-4 border-black px-4 py-1 transform -rotate-2">
          <h3 className="text-white font-comic text-xl uppercase tracking-widest">{title}</h3>
        </div>
      )}
      <div className="mt-2">
        {children}
      </div>
    </div>
  );
};

export default ComicPanel;